import { makeStyles } from "@material-ui/core/styles";
import { tokens } from "../../theme/tokens";

export const useCaseViewStyle = makeStyles((theme) => ({
  //Case.tsx
  postButton: {
    backgroundColor: theme.palette.primary.main,
    fontFamily: tokens.type.family,
    color: tokens.color.brand.onPrimary,
    textTransform: "inherit",
    borderRadius: tokens.radius.sm,
    boxShadow: "none",
    textAlign: "center",
    "&:hover": {
      backgroundColor: tokens.color.brand.primaryActionHover,
      boxShadow: "none",
    },
    height: "35px",
    fontSize: ".9em",
    width: "150px",
    border: `${tokens.borderWidth} solid ${tokens.color.brand.primary}`,
    alignContent: "center",
  },

  // only test
  btn: {
    marginTop: "auto",
    backgroundColor: theme.palette.primary.main,
    fontFamily: tokens.type.family,
    fontSize: "1em",
    color: tokens.color.brand.onPrimary,
    textTransform: "inherit",
    borderRadius: tokens.radius.sm,
    boxShadow: "none",
    textAlign: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: "0.8",
    },
  },

  // Files.tsx
  stack: {
    color: tokens.color.brand.onPrimary,
  },
  icon: {
    color: tokens.color.text.disabled,
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      color: tokens.color.text.primary,
    },
    cursor: "pointer",
  },
  notesHover: {
    color: `${tokens.color.brand.primary} !important`,
    cursor: "pointer",
    "&:hover": {
      color: `${tokens.color.text.primary} !important`,
    },
  },

  //CaseDetails

  heading: {
    marginLeft: "8vh",
    fontSize: "1em",
    color: theme.palette.primary.main,
  },

  iconList: {
    marginLeft: "auto",
  },
  cardContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    alignItems: "start",
    gap: tokens.space[4],
    "@media (max-width: 900px)": {
      gridTemplateColumns: "1fr",
    },
  },
  tabContainers: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: tokens.space[4],
  },
  rightContainer: {},
  // Card title, sitting in the card's header band (with a bottom rule).
  tabHeading: {
    margin: 0,
    color: tokens.color.text.primary,
    fontSize: "0.9375rem",
    fontWeight: tokens.type.denseStrong.weight,
    letterSpacing: "-0.005em",
  },
  cardHead: {
    display: "flex",
    alignItems: "center",
    gap: tokens.space[2],
    boxSizing: "border-box",
    padding: `${tokens.space[3]} ${tokens.space[4]}`,
    borderBottom: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
  },
  cardHeadIcon: {
    color: tokens.color.brand.primaryAction,
    display: "inline-flex",
    "& svg": { fontSize: "1.125rem" },
  },
  cardHeadCount: {
    marginLeft: "auto",
    fontSize: tokens.type.caption.size,
    fontWeight: tokens.type.denseStrong.weight,
    color: tokens.color.text.secondary,
  },
  leftInformationDiv: {
    backgroundColor: tokens.color.surface.default,
    width: "100%",
    boxSizing: "border-box",
    borderRadius: tokens.radius.md,
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    boxShadow: "none",
  },
  rightInformationDiv: {
    backgroundColor: tokens.color.surface.default,
    width: "100%",
    boxSizing: "border-box",
    borderRadius: tokens.radius.md,
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    boxShadow: "none",
  },
  // A single field cell: caption label stacked over its value.
  cardContentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.space[1],
    minWidth: 0,
  },
  fieldWide: {
    gridColumn: "1 / -1",
  },
  label: {
    fontSize: tokens.type.caption.size,
    fontWeight: tokens.type.denseStrong.weight,
    lineHeight: tokens.type.caption.lineHeight,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: tokens.color.text.secondary,
  },

  // Read-only value (email / phone): plain text, no field chrome.
  formikView: {
    color: tokens.color.text.primary,
    fontSize: tokens.type.dense.size,
    display: "flex",
    alignItems: "center",
    minHeight: "36px",
    "& .MuiInputBase-input": {
      textAlign: "left",
    },
  },
  // Editable field: full width, left-aligned, clean bordered surface.
  formikInput: {
    color: tokens.color.text.primary,
    fontSize: tokens.type.dense.size,
    width: "100%",
    height: "36px",
    textAlign: "left",
    backgroundColor: tokens.color.surface.default,
    borderRadius: tokens.radius.sm,
    padding: `0 ${tokens.space[3]}`,
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    transition: `border-color ${tokens.motion.fast} ${tokens.motion.easing}`,
    "& .MuiInputBase-input": {
      textAlign: "left",
      padding: 0,
    },
    "& .MuiSelect-select": {
      paddingRight: "24px",
    },
    "&:hover": {
      border: `${tokens.borderWidth} solid ${tokens.color.border.strong}`,
    },
    "&:focus-within": {
      border: `${tokens.borderWidth} solid ${tokens.color.focus.ring}`,
      boxShadow: "none",
    },
  },
  formikInputValidation: {
    color: tokens.color.status.error,
    fontSize: tokens.type.caption.size,
    marginTop: tokens.space[1],
    width: "100%",
    textAlign: "left",
  },

  tasksPaper: {
    maxWidth: "1200px",
    minWidth: "900px",
  },
  taskDialogHeader: {
    backgroundColor: tokens.color.surface.sunken,
    padding: "10px 20px",
    textAlign: "left",
  },
  taskListText: {
    color: tokens.color.text.primary,
    fontFamily: "1.2rem",
    "& span": {
      fontFamily: tokens.type.family,
      fontSize: "1.1rem",
    },
  },
  tasksList: {
    flexGrow: 1,
  },
  addTasks: {
    width: "30%",
    borderLeft: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    paddingLeft: "18px",
  },
  tasksInput: {
    width: "100%",
    fontFamily: tokens.type.family,
    fontSize: "1.2rem",
    color: tokens.color.text.primary,
  },
  taskIcon: {
    fill: tokens.color.text.primary,
    fontSize: "1.8rem",
    cursor: "pointer",
  },
  taskZoomIcon: {
    width: "25px",
    float: "right",
    marginTop: "12px",
    cursor: "pointer",
  },
  // Two fields per row; wide cells opt into full width via fieldWide.
  infoContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: `${tokens.space[3]} ${tokens.space[4]}`,
    boxSizing: "border-box",
    padding: tokens.space[4],
  },
  labelContainer: {
    minWidth: 0,
  },
  fieldPaddingRight: {
    paddingRight: "23px",
  },

  customTooltip: {
    backgroundColor: tokens.color.surface.default,
    color: tokens.color.text.primary,
    border: `${tokens.borderWidth} solid ${tokens.color.border.strong}`,
    fontSize: ".85rem",
    fontWeight: 400,
    width: "300px",
    padding: "8px",
    textTransform: "inherit",
    zIndex: 9998,
  },
  budgetContainer: {
    width: "100%",
    boxSizing: "border-box",
    padding: tokens.space[4],
    "& .budgetRow": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: tokens.space[3],
      padding: `${tokens.space[2]} 0`,
      borderBottom: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
      "& .MuiTypography-root": {
        fontSize: tokens.type.dense.size,
        color: tokens.color.text.secondary,
      },
    },
    "& .bottomRow": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: tokens.space[3],
      paddingTop: tokens.space[4],
      "& .remLabel": {
        fontSize: tokens.type.caption.size,
        fontWeight: tokens.type.denseStrong.weight,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        color: tokens.color.text.secondary,
      },
      "& .remaining": {
        fontSize: "1.5rem",
        fontWeight: 700,
        color: tokens.color.status.success,
        fontVariantNumeric: "tabular-nums",
      },
    },
  },

  cardBodyPad: {
    boxSizing: "border-box",
    padding: tokens.space[4],
  },
  leftTop: {},
  leftBottom: {},
  textField: {
    width: "100%",
    boxSizing: "border-box",
    minHeight: "120px",
    borderRadius: tokens.radius.sm,
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    backgroundColor: tokens.color.surface.default,
    padding: `${tokens.space[2]} ${tokens.space[3]}`,
    transition: `border-color ${tokens.motion.fast} ${tokens.motion.easing}`,
    "&:hover": { borderColor: tokens.color.border.strong },
    "&:focus-within": { borderColor: tokens.color.focus.ring },
    "& .MuiInputBase-input": {
      color: tokens.color.text.primary,
      fontSize: tokens.type.dense.size,
      lineHeight: tokens.type.body.lineHeight,
    },
  },
  iconHover: {},
}));
